<template>
  <div class="ach-card-list-component" :style="customStyle">
    <!-- 银行卡列表 -->
    <div class="ach-card-list" v-if="cardList.length > 0">
      <div
        v-for="card in cardList"
        :key="card.id"
        class="ach-card-item"
        :class="{ selected: selectedCardId === card.bankAccountToken }"
        :style="
          selectedCardId === card.bankAccountToken
            ? { borderColor: primaryColor }
            : {}
        "
        @click="selectCard(card)"
      >
        <div class="card-info">
          <!-- 展示卡号 -->
          <div class="card-number">
            Account number: *****{{ card.bankSummary }}
          </div>
          <div class="account-holder">Holder name: {{ card.ownerName }}</div>
          <!-- <div class="account-type">{{ card.bankAccountToken }}</div> -->
        </div>
        <div class="card-actions" v-if="showActions">
          <van-icon name="delete" @click.stop="confirmDelete(card)" />
        </div>
      </div>
    </div>

    <!-- 添加新账户按钮 -->
    <div class="ach-card-list" v-if="showAddButton && cardList.length > 0">
      <div
        class="ach-card-item add-card-item"
        :class="{ selected: selectedCardId === 'new-card' }"
        :style="
          selectedCardId === 'new-card' ? { borderColor: primaryColor } : {}
        "
        @click="$emit('add-new-card')"
      >
        <div class="add-card-content">
          <van-icon name="plus" size="24" color="#999" />
          <div class="add-card-text">{{ $t("common.addNewCard") }}</div>
        </div>
      </div>
    </div>

    <!-- 删除确认弹窗 -->
    <van-dialog
      v-model="showDeleteDialog"
      :title="$t('common.deleteCardConfirmTitle')"
      show-cancel-button
      :cancel-button-text="$t('common.deleteCardCancel')"
      :show-confirm-button="true"
      :confirm-button-text="$t('common.deleteCardConfirm')"
      :confirm-button-color="primaryColor"
      @cancel="handleCancel"
      @confirm="handleDelete"
    >
      <p class="delete-message">{{ $t("common.deleteCardConfirmText") }}</p>
    </van-dialog>
  </div>
</template>

<script>
// import { Toast } from 'vant';
import indexMixin from "../mixins/index";

export default {
  name: "AchCardListComponent",
  mixins: [indexMixin],
  props: {
    // 银行卡列表数据
    cardList: {
      type: Array,
      default: () => []
    },
    // 是否显示操作按钮（删除）
    showActions: {
      type: Boolean,
      default: true
    },
    // 是否显示添加新账户按钮
    showAddButton: {
      type: Boolean,
      default: true
    },
    // 初始选中的卡ID
    initialSelectedCardId: {
      type: [String, Number],
      default: null
    },
    // 主色调
    primaryColor: {
      type: String,
      default: "#ffaa0a"
    }
  },
  data() {
    return {
      selectedCardId: null,
      cardToDelete: null,
      showDeleteDialog: false
    };
  },
  computed: {
    // 计算样式属性，包括CSS变量
    customStyle() {
      return {
        "--primary-color": this.primaryColor
      };
    }
  },
  watch: {
    initialSelectedCardId: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.selectedCardId = newValue;
        }
      }
    }
  },
  methods: {
    /**
     * 选择银行卡
     */
    selectCard(card) {
      this.selectedCardId = card.bankAccountToken;
      this.$emit("card-selected", card);
      this.reportLog({
        eventId: "SELECTCARD_H5",
        msg: ""
      });
    },

    /**
     * 确认删除银行卡
     */
    confirmDelete(card) {
      this.cardToDelete = card;
      this.showDeleteDialog = true;
      this.reportLog({
        eventId: "DELETECARD_H5",
        msg: ""
      });
    },

    /**
     * 删除银行卡
     */
    handleDelete() {
      this.reportLog({
        eventId: "DELETECARD_SHOW_H5",
        msg: ""
      });
      if (!this.cardToDelete) return;

      this.$emit("delete-card", this.cardToDelete);
      // Toast.success('删除成功');

      this.cardToDelete = null;
    },

    /**
     * 取消删除
     */
    handleCancel() {
      this.reportLog({
        eventId: "DELETECARD_CANCEL_H5",
        msg: ""
      });
    },

    /**
     * 获取当前选中的卡
     */
    getSelectedCard() {
      if (this.selectedCardId === "new-card") {
        return { isNewCard: true };
      }

      return (
        this.cardList.find(
          card => card.bankAccountToken === this.selectedCardId
        ) || null
      );
    },

    /**
     * 公开方法：清除选中状态
     */
    clearSelection() {
      this.selectedCardId = null;
    },

    /**
     * 公开方法：设置选中卡片
     */
    setSelectedCard(cardId) {
      this.selectedCardId = cardId;
    }
  },
  mounted() {
    // 如果有initialSelectedCardId，优先使用它
    if (this.initialSelectedCardId) {
      this.selectedCardId = this.initialSelectedCardId;
    }
    // 否则默认选中第一张卡
    else if (this.cardList.length > 0) {
      this.selectedCardId = this.cardList[0].bankAccountToken;
      this.$emit("card-selected", this.cardList[0]);
    }
  }
};
</script>

<style lang="less" scoped>
// 定义Less变量
@primary-color: #ffaa0a; // 默认值

.ach-card-list-component {
  // 使用CSS变量
  .ach-card-list {
    .ach-card-item {
      margin-bottom: 16px;
      padding: 12px;
      border-radius: 8px;
      background-color: #fff;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
      position: relative;
      overflow: hidden;
      transition: all 0.3s;
      border: 2px solid transparent;

      &.selected {
        // 直接使用固定颜色，确保至少有黄色边框
        border: 2px solid #ffaa0a !important;
      }

      &:active {
        background-color: #f5f5f5;
      }

      &.add-card-item {
        display: flex;
        justify-content: center;
        align-items: center;
        min-height: 80px;
        border: 2px dashed #999;
        background-color: #fff;
        cursor: pointer;

        &.selected {
          // 直接使用固定颜色，确保至少有黄色边框
          border: 2px solid #ffaa0a !important;
        }

        .add-card-content {
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          width: 100%;

          .add-card-text {
            margin-left: 8px;
            color: #999;
            font-size: 14px;
            font-weight: 500;
          }
        }

        &:active {
          background-color: rgba(255, 170, 10, 0.1);
        }
      }

      .card-info {
        margin-top: 10px;
        padding: 0 8px;

        .account-holder,
        .card-number {
          font-size: 14px;
          color: #333;
          margin-bottom: 10px;
        }

        .account-type {
          font-size: 12px;
          color: #666;
        }
      }

      .card-actions {
        position: absolute;
        top: 12px;
        right: 12px;

        .van-icon {
          font-size: 18px;
          color: #999;
          padding: 5px;

          &:active {
            color: #ffaa0a;
          }
        }
      }
    }
  }

  .delete-message {
    padding: 16px;
    text-align: center;
  }
}
.ach-card-list-component .adyen-checkout__field {
  display: block !important;
}
</style>
